import Component from 'gia/Component'
import eventbus from 'gia/eventbus';
import stage from '../components/stage'
import renderer from '../components/render'

import _each from 'lodash.foreach'




class Expert extends Component {

  constructor(element) {

    super(element)

    this.body = document.body
    this.element = element
    this.i = 0


    this.ref = {
     slot: []
    }

  }

  mount() {

    

  
    this.getItems()
   
   

    }   
    
    populate() {
      this.ref.slot.forEach((slot, i) => {

        const arr = slot.dataset.slot
        const sample = this.json[arr]

        sample.forEach((item, i) => {
          const box = document.createElement("option");
          box.classList.add("slot");
          box.textContent = item
          slot.append(box)
        })

      })
    }


    getItems() {

      fetch('/data/data.json')
        .then((response) => response.json())
        .then((json) => {

          //   this.facestock = json[0].facestock;
          //   this.adhesive = json[0].adhesive;
          //   this.liner = json[0].liner;
          //   this.ink = json[0].ink;
          //   this.size = json[0].size;

          this.json = json[0]
          this.populate()

        });
    }



    resize(){

       


       

    }

    unmount() {



    }

}

module.exports = Expert



